import React from "react";
import { ArrowRight } from "@speedoc/design-assets/build/icons/index.js";
import ContainerCard from "./containerCard";
import { Link } from "react-router-dom";
import { slugToCountryPathname, wordEllipsis } from "../../utils/strings";
import { LazyLoadImage } from "react-lazy-load-image-component";
import moment from "moment";

function ArticleCard({ content }) {
  const filters =
    (content.filterTags || [])
      .map(element => element.tag)
      .join(", ")
      .toUpperCase() || "HEALTH";

  let preview = content.meta?.seo?.description?.substring(0, 100);
  preview = preview?.concat(content.meta.seo.description.length > 100 ? "..." : "");

  return (
    <Link to={slugToCountryPathname(content.slug)} className="articleCardLink">
      <ContainerCard>
        <div className="articleCard">
          <div className="image">
            <LazyLoadImage src={content.header?.heroImage?.formats?.small?.url} alt="Speedoc article" effect="blur" />
          </div>
          <div className="content">
            <div className="category">{filters}</div>
            <div className="headline">{wordEllipsis(content.title, 50)}</div>
            <div className="preview">{preview}</div>
            <div className="link">
              Learn More <ArrowRight className="arrow right" />
            </div>
          </div>
        </div>
      </ContainerCard>
    </Link>
  );
}

function ArticleCardV4({ content }) {
  return (
    <Link to={slugToCountryPathname(content.slug)} className="articleCardLink">
      <ContainerCard>
        <div className="articleCardV4">
          <div className="image">
            <LazyLoadImage src={content.header?.heroImage?.formats?.small?.url} alt="Speedoc article" effect="blur" />
          </div>
          <div className="content">
            <div className="filterTags">
              {content.filterTags.map((item, index) => (
                <div key={index} className="category">
                  {item.tag.toUpperCase()}
                </div>
              ))}
            </div>
            <div className="headline">{wordEllipsis(content.title, 50)}</div>
            <div className="publicationDate">{moment(content.publicationDate).format("DD MMM YYYY").toUpperCase()}</div>
            <div className="link">Read More</div>
          </div>
        </div>
      </ContainerCard>
    </Link>
  );
}

let temp = process.env.REACT_APP_V4_ENABLE === "true" ? ArticleCardV4 : ArticleCard;
export default temp;
